import { Logger } from "@smiles/core-engine";
import axios from "axios";

export const FileEnvironment = async (): Promise<'blue' | 'green'> => {
    try {
      const timestamp = new Date().getTime();
      const checkEnv = await axios.get('https://www.smiles.com.br/mfe-apps/check-env.txt', {
        params: {
          t: timestamp,
        },
      });

      return checkEnv.data;
    } catch (error) {
      Logger.error(`LaunchDarklyFileEnvironment: ${error}`);
      return 'green';
    }
  };
  